export default __webpack_public_path__ + "static/media/search.7f329904.svg";